var _defs, _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigUpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 277 277",
    width: 277,
    height: 277,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,122,-273,0,138.5,77)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none; stroke: #ff7700; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2; stroke-dasharray: 109 } \n\t\t.s1 { fill: url(#g1) } \n\t\t.s2 { fill: #706f6e } \n\t\t.s3 { fill: #27803b } \n\t\t.s4 { fill: #e9661c } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m280-4v284h-284v-284z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m2 77h273v122h-273z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s2",
    d: "m202.4 169.9h-12.9l18-64.8h12.9zm-6.2-58l-7.2 25.9q-0.8 2.8-3.1 4.6-2.4 1.9-5.2 1.9h-58l-7.2 25.9h-12.9l10.7-38.7h12.9v0.1h51.7l3.7-13.6h-64.5l3.5-12.7h70.9q2.9 0 4.2 1.9c0.9 1.2 1 2.8 0.5 4.7zm-101.1 53.9c-0.7 2.6-3.1 4.4-5.7 4.4h-66.6q-2.7 0-4-1.9-1.4-1.8-0.6-4.5l16.3-58.5h12.9l-14.5 52.2h51.6l14.5-52.2h12.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m242.7 105.2l16.3 32.5-34.3 32.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m231.2 105.2l16.3 32.5-34.3 32.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigUpi);
export default __webpack_public_path__ + "static/media/bigUpi.cd156b43de33179fd094a44c163c12ee.svg";
export { ForwardRef as ReactComponent };